//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "backGuide",
    data () {
        return {

        }
    },
    mounted() {

    },
    methods: {
        // 关闭弹框
        handleCloseGuide: function(value) {
            this.$burialPoint.addEvent('entry.close');
            this.$emit('close',value)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/backGuide.vue